export const validateIsInteger = value => {
  if (value.trim() === '') {
    return true
  }
  return !isNaN(Number(value)) && Number(value) % 1 === 0
}
